/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { AddIcon } from "@dotnet/telematics-design-system";

import { COMPANY_CARDS_LIMITS } from "../../../../../../../../Pages/Companies/types";
import {
  COMPANIES_ACTIONS,
  TUTORIAL_IDS
} from "../../../../../../../../shared";
import Button from "../../../../../../../Button/Button";
import { useDialog } from "../../../../../../../PageHeader/actions/hooks/useDialog";
import Tooltip from "../../../../../../../Tooltip/Tooltip";
import useTutorialMode from "../../../../../../../TutorialMode/hooks/useTutorialMode";
import AddCompanyCardDialog from "../../../../../../actions/dialogs/companies/AddCompanyCardDialog/AddCompanyCardDialog";
import { DetailsDataType } from "../../../../../../types";

interface AddcompanyCardLinkProps {
  detailsData: DetailsDataType;
  cardsCount: number;
}

const AddCompanyCardButton = ({
  detailsData,
  cardsCount
}: AddcompanyCardLinkProps) => {
  const { isTutorialActive } = useTutorialMode();

  const { t } = useTranslation();
  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  const isDisabled = cardsCount >= COMPANY_CARDS_LIMITS.MaxResourceCount;

  const handleLinkClick = () => {
    if (!isDisabled && !isTutorialActive)
      openDialog(COMPANIES_ACTIONS.CreateNewCompanyCard);
  };

  const handleCloseDialog = () => {
    closeDialog(COMPANIES_ACTIONS.CreateNewCompanyCard);
  };

  return (
    <>
      <Tooltip
        title={t(`Details##company cards limit reached`, {
          currCount: cardsCount,
          maxCount: COMPANY_CARDS_LIMITS.MaxResourceCount
        })}
        placement="top-end"
        hasArrow
        size="medium"
        disableHoverListener={!isDisabled}
      >
        <span>
          <Button
            id={TUTORIAL_IDS.AddNewCompanyCardComponent}
            data-testid="add-new-card-button"
            color="secondary"
            onClick={handleLinkClick}
            size="tiny"
            variant="iconLeft"
            disabled={isDisabled}
            css={css([isTutorialActive && { cursor: "auto" }])}
            icon={
              <AddIcon
                css={css({
                  marginRight: "-2px",
                  width: "16px",
                  height: "16px"
                })}
              />
            }
          >
            {t("Company cards##add new")}
          </Button>
        </span>
      </Tooltip>

      <AddCompanyCardDialog
        open={isDialogOpen[COMPANIES_ACTIONS.CreateNewCompanyCard]}
        onClose={handleCloseDialog}
        detailsData={detailsData}
      />
    </>
  );
};

export default AddCompanyCardButton;
